/**
 * @Author : zhouqinze
 * @Date : 2020-1-2
 * @Version : 1.0
 * @Content : 新闻栏目
 **/
<template>
    <div class="news">
        <div class="content">
            <div class="tarbar"><p>首页</p><span>></span><p>新闻动态</p><span>></span><p>详情</p></div>
            <div class="newsTitle"><h1>江西省公路治理超限超载综合管理平台应用软件开发项目启动会</h1></div>
            <div class="newsResume">
                <span class="source">来源：广州通易科技有限公司</span>
                <span class="showDate">日期：2019-12-31</span>
            </div>
            <div class="newsImg"><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_xwdt_photo.png" alt=""></div>
            <div class="newsCon">
                <p>2019年12月9日，在江西省公路管理局路网管理中心，召开《江西省公路治理超限超载综合管理平台应用软件开发》项目启动会。</p>
                <p>作为该项目的承建单位，广州通易科技的研发团队，基于十年交通执法业务的沉淀，结合大量的前期调研工作，编制出符合本项目的实施方案，从系统概述、需求设计、实施策略、实施计划等方面，对项目建设做了详细的规划，得到省公路管理局领导、监理公司等一致肯定与好评。</p>
            </div>
            <div class="weilei"></div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .news{
        width: 100%;
        background: #fff;
        position: relative;
        .content{
            width: 75rem;
            margin: auto;
            overflow: hidden;
            // .weilei{
            //     height: 20px;
            //     width: 100%;
            //     position: absolute;
            //     bottom: 0;
            //     background: red;
            //     // top: -85px;
            //     // height: 80px;
            //     // opacity: 0;
            //     // background: red;
            // }
            .tarbar{
                height: 3.75rem;
                box-sizing: border-box;
                border-bottom: .0625rem solid #ccc;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                p{
                    font-size: .8125rem;
                    height: .8125rem;
                    line-height: .8125rem;
                    font-weight: bold;
                    color: #222;
                    padding: 0 .625rem;
                }
                span{
                    color: #666;
                    font-size: .625rem;
                    line-height: .625rem;
                }
                margin-bottom: 2.6875rem;
            }
            .newsTitle{
                h1{
                    color: #018CF4;
                    font-size: 1.5rem;
                    height: 1.5rem;
                    line-height: 1.5rem;
                }
                margin-bottom: 1.5625rem;
            }
            .newsResume{
                display: flex;
                justify-content: center;
                font-size: .875rem;
                line-height: .875rem;
                .source{
                    margin-right: 2em;
                }
                .showDate{

                }
                margin-bottom: 2.5625rem;
            }
            .newsImg{
                img{
                    display: block;
                    margin: auto;
                }
                margin-bottom: 2.375rem;
            }
            .newsCon{
                text-align: left;
                p{
                    font-size: .9375rem;
                    color: #222;
                    line-height: 3em;
                }
                margin-bottom: 6.25rem;
            }
        }
    }
</style>